import { AppContext } from "app/AppContext";
import axios from "axios";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useUsuarioByEmail } from 'services/autenticacion/usuarios/get'
import { buildExternalUserHeaders } from "./externalUserHeaders";

export function useMotivosExterno() {
  const [reasonExterno, setReasonExterno] = useState([]);
  const { envConfig } = useContext(AppContext)
  const { data: userData } = useUsuarioByEmail(Boolean(envConfig), envConfig)
  const requestHeaders = useMemo(
    () => buildExternalUserHeaders(userData),
    [userData]
  )
  const getReasonExternal = useCallback(async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL_REQUESTS}/data-master/reasons`,
      { headers: requestHeaders }
    );
    setReasonExterno(response.data);
  }, [requestHeaders]);

  useEffect(() => {
    getReasonExternal();
  }, [getReasonExternal]);

  return { reasonExterno };
}
